var map = {
	"./BackButton.svg": "9e13",
	"./ComingSoonCuBg.svg": "8395",
	"./CoverFinal.svg": "3461",
	"./HowToPlay.svg": "b7f5",
	"./MoreOption.svg": "05b8",
	"./VivaLogo.svg": "56b1",
	"./downloadBtn.svg": "ba2c",
	"./login.svg": "ebec",
	"./newsletter.svg": "c7f5",
	"./panglicaSolved.svg": "0c97",
	"./rating.svg": "4489",
	"./rules.svg": "6a50",
	"./sendPassword.svg": "5f59",
	"./termsAndConditions.svg": "3020",
	"./trofeu.svg": "bc07"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";